import apiClient from "../../../utils/clients/axios";

export const getYard = async (payload) => {
  const response = await apiClient.get(
    `/api/quality_control/finisher`,
    payload
  );
  return response;
};

export const yardCreate = async (payload) => {
  const response = await apiClient.post(
    `/api/quality_control/finisher`,
    payload
  );
  return response;
};
